<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem';

const props = defineProps<{ item: MenuItem }>();
</script>

<template>
  <router-link
    :to="props.item.route"
    class="link-ns btn btn-ghost btn-sm text-nowrap w-full h-10 px-2 py-2 text-left rounded-none font-semibold cursor-pointer select-none touch-manipulation transition-colors duration-150"
    :class="props.item.isRootItem ? 'text-lg' : 'text-sm'"
  >
    <div class="flex items-center w-full gap-2">
      <template v-if="props.item.image">
        <img :src="props.item.image" class="size-5 rounded">
      </template>
      <template v-else-if="props.item.icon">
        <i :class="'text-primary p-menu-item-icon pi ' + props.item.icon"></i>
      </template>
      <div>{{ props.item.label }}</div>
    </div>
  </router-link>
</template>